import {
  getChecklists,
  getChecklistAmount,
  getMoveInSchedulerTime,
  postMoveInSchedulerTime,
  postSaveChecklistWatchVideo,
  postAddToCalendar,
  postInsertEventToCalendar,
} from 'portal-modules/checklists/api/api'
import { call, put, takeLatest, all } from 'redux-saga/effects'
import { LOGOUT } from 'portal-modules/auth/redux/modules/user'
import createRequestSaga,{
  handleResponseError,
} from 'portal-modules/common/redux/create-request-saga'
import { addError } from 'portal-modules/common/redux/modules/errors'
import { clearCalendarAuthCode } from 'portal-modules/checklists/constants/utils'
import { getEmbeddedViewFlag } from 'portal-modules/common/utils/get-embedded-flag'

// action types
export const REQUEST_CHECKLISTS = 'rp/checklist/REQUEST_CHECKLISTS'
export const RECEIVE_CHECKLISTS = 'rp/checklist/RECEIVE_CHECKLISTS'
export const REQUEST_CHECKLIST_AMOUNT = 'rp/checklist/REQUEST_CHECKLIST_AMOUNT'
export const RECEIVE_CHECKLIST_AMOUNT = 'rp/checklist/RECEIVE_CHECKLIST_AMOUNT'
export const REQUEST_SCHEDULER_TIME = 'rp/checklist/REQUEST_SCHEDULER_TIME'
export const RECEIVE_SCHEDULER_TIME = 'rp/checklist/RECEIVE_SCHEDULER_TIME'
export const SAVE_SCHEDULER_TIME = 'rp/checklist/SAVE_SCHEDULER_TIME'
export const SAVE_CHECKLIST_WACHED_VIDEO =
  'rp/checklist/SAVE_CHECKLIST_WACHED_VIDEO'
export const UPDATE_SCHEDULER_TIME = 'rp/checklist/UPDATE_SCHEDULER_TIME'
export const MOVE_IN_SCHEDULED = 'rp/checklist/MOVE_IN_SCHEDULED'
export const ADD_TO_CALENDAR = 'rp/checklist/ADD_TO_CALENDAR'
export const INSERT_EVENT_TO_CALENDAR = 'rp/checklist/INSERT_EVENT_TO_CALENDAR'
export const UPDATE_EVENT_TO_CALENDAR = 'rp/checklist/UPDATE_EVENT_TO_CALENDAR'
export const REQUEST_CHECKLIST_RELOAD = 'rp/checklist/REQUEST_CHECKLIST_RELOAD'

// action creators
export const requestChecklists = () => ({
  type: REQUEST_CHECKLISTS,
})

export const requestChecklistReload = payload => ({
  type: REQUEST_CHECKLIST_RELOAD,
  payload,
})

export const requestChecklistAmount = (payload, callback) => ({
  type: REQUEST_CHECKLIST_AMOUNT,
  payload,
  callback,
})

export const receiveChecklists = payload => ({
  type: RECEIVE_CHECKLISTS,
  payload,
})

export const requestSchedulerTime = () => ({
  type: REQUEST_SCHEDULER_TIME,
})

export const receiveSchedulerTime = payload => ({
  type: RECEIVE_SCHEDULER_TIME,
  payload,
})

export const saveMoveInSchedulerTime = (payload, callback, isUpdate) => ({
  type: isUpdate ? UPDATE_SCHEDULER_TIME : SAVE_SCHEDULER_TIME,
  callback,
  payload,
})

export const saveChecklistWatchedVideo = (payload, callback) => ({
  type: SAVE_CHECKLIST_WACHED_VIDEO,
  callback,
  payload,
})

export const addToCalendar = (payload, callback) => ({
  type: ADD_TO_CALENDAR,
  callback,
  payload,
})

export const insertEventToCalendar = payload => ({
  type: INSERT_EVENT_TO_CALENDAR,
  payload,
})

// reducer
export default (state = {}, { payload, type }) => {
  switch (type) {
    case RECEIVE_CHECKLISTS:
      return {
        ...state,
        ...payload,
        requested: true,
        isEventAdded: false,
        message: '',
      }
    case RECEIVE_SCHEDULER_TIME:
      return { ...state, ...payload, isEventAdded: false, message: '' }
    case MOVE_IN_SCHEDULED:
      return { ...state, ...payload, isEventAdded: false, message: '' }
    case LOGOUT:
      return {}
    case RECEIVE_CHECKLIST_AMOUNT:
      return {...state,...payload}
    case UPDATE_EVENT_TO_CALENDAR:
      return { ...state, ...payload }
    case REQUEST_CHECKLIST_RELOAD:
      return { ...state, ...payload }
    default:
      return state
  }
}

function* fetchChecklists() {
  const checklistItems = yield call(getChecklists)
  if (!checklistItems) {
    yield put({
      type: RECEIVE_CHECKLISTS,
      payload: { move_out_checklist: {}, move_in_checklist: {} },
    })
  } else if (checklistItems) {
    yield put({
      type: RECEIVE_CHECKLISTS,
      payload: checklistItems,
    })
  }
}

function* handleRequestChecklistError({ message }, { key }) {
  yield put(addError(key, message))
  yield put({
    type: RECEIVE_CHECKLISTS,
    payload: {},
  })
}

export function* handleChecklistError(err) { 
  const newErr = {
    ...err,
    fields: [ err?.fields || [] ],
  }
  const key = getEmbeddedViewFlag() ? 'apex_payments' : 'payments';
  yield call(handleResponseError, newErr, { key });
}

function* fetchSchedulerTime() {
  const checklistItems = yield call(getMoveInSchedulerTime)
  if (checklistItems) {
    yield put({
      type: RECEIVE_SCHEDULER_TIME,
      payload: checklistItems,
    })
  }
}

export function* fetchChecklistAmount({ payload, callback }) {
  const rate = yield call(getChecklistAmount, payload)
  if(rate){
    yield put ({
      type: RECEIVE_CHECKLIST_AMOUNT,
      payload: {rate}
    })
  }
  typeof callback === 'function' && callback(rate)
}

function* saveChecklistWatchVideo({ payload, callback }) {
  yield call(postSaveChecklistWatchVideo, {
    checklist_info: JSON.stringify(payload),
  })
  typeof callback == 'function' && callback()
}

function* handleAddToCalendar({ payload, callback }) {
  const response = yield call(postAddToCalendar, {
    payload,
  })

  typeof callback == 'function' && response && callback(response.url)
}

function* handleInsertEventToCalendar({ payload }) {
  clearCalendarAuthCode()
  const response = yield call(postInsertEventToCalendar, {
    payload,
  })

  if (response) {
    yield put({
      type: UPDATE_EVENT_TO_CALENDAR,
      payload: response,
    })
  }
}

function* scheduleMoveIn({ payload, callback }) {
  const response = yield call(postMoveInSchedulerTime, payload)

  if (response && response.result) {
    yield all([
      put({
        type: REQUEST_SCHEDULER_TIME,
      }),
      put({
        type: MOVE_IN_SCHEDULED,
        payload: { isScheduledMoveIn: response.result },
      }),
    ])
    typeof callback == 'function' && callback()
  }
}

export function* watchRequestChecklists() {
  yield takeLatest(
    REQUEST_CHECKLISTS,
    createRequestSaga(fetchChecklists, {
      key: 'checklist',
      message: __('Checking for checklist items'),
      onError: handleRequestChecklistError,
    }),
  )
}

export function* watcheAddToCalendar() {
  yield takeLatest(
    ADD_TO_CALENDAR,
    createRequestSaga(handleAddToCalendar, {
      key: 'add_calendar',
      message: __('Authorizing user'),
    }),
  )
}

export function* watchChecklistAmount() {
  yield takeLatest(
    REQUEST_CHECKLIST_AMOUNT,
    createRequestSaga(fetchChecklistAmount, {
      key: 'checklist',
      message: __('Fetching amount'),
      successMessage: __('Fetched Successful'),
      write: true,
      onError: handleChecklistError,
    }),
  )
}

export function* watcheInsertEventToCalendar() {
  yield takeLatest(
    INSERT_EVENT_TO_CALENDAR,
    createRequestSaga(handleInsertEventToCalendar, {
      key: 'add_calendar',
      message: __('Adding event in calendar'),
      successMessage: __('Added Event in calendar successfully.'),
      write: true,
    }),
  )
}

export function* watchRequestSchedulerTime() {
  yield takeLatest(
    REQUEST_SCHEDULER_TIME,
    createRequestSaga(fetchSchedulerTime, {
      key: 'checklist',
      message: __('Checking for checklist items'),
    }),
  )
}

export function* watchSaveMoveInSchedulerTime() {
  yield takeLatest(
    SAVE_SCHEDULER_TIME,
    createRequestSaga(scheduleMoveIn, {
      key: 'checklist',
      message: __('Scheduling Move-In'),
    }),
  )
}

export function* watchSaveChecklistWatchedVideo() {
  yield takeLatest(
    SAVE_CHECKLIST_WACHED_VIDEO,
    createRequestSaga(saveChecklistWatchVideo, {
      key: 'checklist',
      message: __('Saving Watch Video Completed...'),
    }),
  )
}
export function* watchUpdateMoveInSchedulerTime() {
  yield takeLatest(
    UPDATE_SCHEDULER_TIME,
    createRequestSaga(scheduleMoveIn, {
      key: 'checklist',
      message: __('Updating Move-In'),
    }),
  )
}

export const sagas = [
  watchRequestChecklists,
  watchRequestSchedulerTime,
  watchSaveMoveInSchedulerTime,
  watchSaveChecklistWatchedVideo,
  watchUpdateMoveInSchedulerTime,
  watcheAddToCalendar,
  watcheInsertEventToCalendar,
  watchChecklistAmount
]
